<div *ngIf="isVisible" class="map-panel absolute bottom-0 right-0 w-30 z-500 flex flex-col h-full shadow-black" [@openClose]>

  <div class="p-4 flex justify-between align-middle bg-white">
    <span class="font-semibold text-sm">{{'map-panel.header' | translate}}</span>
    <app-close-button class="self-center" width="w-3" height="h-3" (close)="onClosePanel()"></app-close-button>
  </div>

  <div class="tk-border-gray-5"></div>

  <div class="px-2">
    <div class="tk-i-emapa w-full h-18 mt-3 cursor-pointer rounded-xl"
         [ngClass]="{'tk-border-2-blue': isEmapaSelected}"
         (click)="onSetEmapa()"></div>
    <div>{{'map-panel.emapa' | translate}}</div>

    <ng-container *ngIf="isGoogleMapsVisible">
      <div class="tk-i-google w-full h-18 mt-3 cursor-pointer rounded-xl"
           [ngClass]="{'tk-border-2-blue': isGoogleMapsSelected}"
           (click)="onSetGoogleRoadmap()"></div>
      <div>{{'map-panel.google-map' | translate}}</div>

      <div class="tk-i-google-satellite w-full h-18 mt-3 cursor-pointer rounded-xl"
           [ngClass]="{'tk-border-2-blue': isGoogleSatelliteSelected}"
           (click)="onSetGoogleHybrid()"></div>
      <div>{{'map-panel.google-satellite' | translate}}</div>
    </ng-container>

    <div class="tk-i-openstreet w-full h-18 mt-3 cursor-pointer rounded-xl"
         [ngClass]="{'tk-border-2-blue': isOpenStreetSelected}"
         (click)="onSetOpenStreet()"></div>
    <div>{{'map-panel.osm' | translate}}</div>

    <!--    <div class="tk-i-openstreet-transport w-full h-18 mt-3 cursor-pointer rounded-xl"-->
    <!--         [ngClass]="{'tk-border-2-blue': isOpenStreetTransportSelected}"-->
    <!--         (click)="onSetOpenStreetTransport()"></div>-->
    <!--    <div>OSM Transport</div>-->
  </div>

</div>
